import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  private _showLoader: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public showLoader$ = this._showLoader.asObservable()
    .pipe(
      distinctUntilChanged()
    );
  private requestCount = 0;
  public requestStart() {
    this.requestCount++;
    this._showLoader.next(true);
  }
  public requestComplete() {

    if (this.requestCount) {
      this.requestCount--;
    }
    if (!this.requestCount) {
      this._showLoader.next(false);
    }
  }
}
